// src/pages/Login.jsx
import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "../style/login.css";

const Login = ({ onLoginSuccess }) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");

    try {
      const formData = new FormData();
      formData.append("username", username.trim());
      formData.append("password", password);

      const response = await fetch("https://marketbusters.pro/login1.php", {
        method: "POST",
        body: formData,
        credentials: "include",
      });

      let data = null;
      try {
        data = await response.json();
      } catch {
        data = { success: false, message: "Respuesta no válida del servidor." };
      }

      if (response.ok && data?.success) {
        const token = data.token || "dummy-token"; // token puede no venir del backend
        const role = data.user?.role || "user";
        const uname = data.user?.username || username.trim();

        localStorage.setItem("token", token);
        localStorage.setItem("role", role);
        localStorage.setItem("username", uname);

        onLoginSuccess(token);

        // Redirección según rol
        if (role === "transportadora") {
          navigate("/transportadora", { replace: true });
        } else {
          navigate("/informes", { replace: true });
        }
      } else {
        const msg =
          data?.message ||
          (response.status === 401
            ? "Nombre de usuario o contraseña incorrectos."
            : "No se pudo iniciar sesión.");
        setMessage(msg);
      }
    } catch (error) {
      setMessage("Error al conectar con el servidor.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <div className="login-title">
          <img
            src="https://marketbusters.pro/imagenes/DALL·E-2024-05-14-21.png"
            alt="Logo Market Busters"
          />
          <h2>Iniciar Sesión</h2>
        </div>

        {message && <div className="message">{message}</div>}

        <form onSubmit={handleSubmit}>
          <div className="user-box">
            <input
              type="text"
              name="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              autoComplete="username"
            />
            <label>Nombre de Usuario</label>
          </div>

          <div className="user-box">
            <input
              type="password"
              name="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              autoComplete="current-password"
            />
            <label>Contraseña</label>
          </div>

          <button type="submit" disabled={loading}>
            {loading ? "Cargando..." : "Entrar"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
